import { FilterSidebarLayout, useBreadcrumbs } from '@mews-commander/ui';
import { lt } from '@mews/framework';
import { useTableState } from '@optimus-web/core';
import {
    attachmentsTableFilterSchema,
    AttachmentsTableFilterValues,
} from '../components/attachmentLibrary/attachmentTable/AttachmentLibraryFilters';
import { AttachmentLibraryTable } from '../components/attachmentLibrary/attachmentTable/AttachmentLibraryTable';
import { useFilteredAttachmentsTableData } from '../components/attachmentLibrary/attachmentTable/hooks/useFilterAttachmentLibraryData';
import { AttachmentLibraryTableRowData } from '../components/attachmentLibrary/attachmentTable/types';
import { useLibraryTabs } from '../components/common/hooks/useLibraryTabs';
import { AttachmentsTableFiltersForm } from '../components/attachmentLibrary/attachmentTable/AttachmentsTableFiltersForm';

const DEFAULT_FILTER_VALUES = { name: '', service: [], type: [] };

export const AttachmentLibrary = ({ searchParams }: { searchParams: AttachmentsTableFilterValues }) => {
    const [tableState, setTableState] = useTableState<AttachmentLibraryTableRowData>({
        pagination: { show: false },
    });

    const breadcrumbs = useBreadcrumbs();
    const tabs = useLibraryTabs();

    const filteredTableData = useFilteredAttachmentsTableData({
        filters: searchParams,
        tableSearchValue: tableState.globalFilters.search,
    });

    return (
        <FilterSidebarLayout
            breadcrumbs={breadcrumbs}
            tabs={tabs}
            filterSchema={attachmentsTableFilterSchema}
            filterSidebar={{ title: lt('Filter'), fields: <AttachmentsTableFiltersForm /> }}
            defaultFilterValues={DEFAULT_FILTER_VALUES}
            filterSidebarOpenedByDefault={false}
            submitButtonLabel={lt('ApplyFilters')}
            withClearFilters
        >
            <AttachmentLibraryTable
                data={filteredTableData}
                loading={false}
                tableState={tableState}
                onTableStateChange={setTableState}
            />
        </FilterSidebarLayout>
    );
};
